import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const InfoPill = ({ left, right }) => {


  return (
    <div className="me-2 mt-0">
      <span
        style={{
          fontSize: ".8rem",
          fontWeight: "bold",
          padding: ".7rem .0rem .7rem 1rem",
          backgroundColor: "var(--theme-color2)",
          borderRadius: ".5rem",
          color: "var(--theme-text-and-icon-color)"

        }}
      >
        {left}{" "}
        <span
          style={{
            color: "#fff",
            paddingTop: ".3rem",
            paddingBottom: ".4rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            fontSize: "1rem",
            fontWeight: "bold",
            marginLeft: "1rem",
            backgroundColor: " var(--theme-color1)",
            borderTopRightRadius: ".5rem",
            borderBottomRightRadius: ".5rem",
            border: "1px solid black",
            borderRadius: "6px",
          }}
        >
          {right}
        </span>
      </span>
    </div>


  );
};

export default InfoPill;